function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7972",
  d: "M262.638 669.552h-22.955a2.011 2.011 0 1 0 0 4.022h22.955a2.011 2.011 0 1 0 0-4.022z",
  className: "cls-1",
  "data-name": "Caminho 7972",
  transform: "translate(-226.308 -621.157)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7973",
  d: "M280.932 695.572l-14.76-27.195V657.2a4.918 4.918 0 0 0-2.4-9.241h-12.636a4.919 4.919 0 0 0-2.355 9.268v11.251L233.7 695.485a8.594 8.594 0 0 0 7.507 12.784h32.167a8.6 8.6 0 0 0 7.556-12.7zm-36.87-10.388l8.488-15.206a1.985 1.985 0 0 0 .258-.979v-12.114a1.92 1.92 0 0 0 .343-1.058 2.015 2.015 0 0 0-2.015-2.01.919.919 0 1 1 0-1.837h12.634a.919.919 0 1 1 0 1.837 2.015 2.015 0 0 0-2.012 2.01 1.965 1.965 0 0 0 .39 1.134v11.928a2.033 2.033 0 0 0 .244.959l6.028 11.108 2.375 4.376 6.6 12.163a4.573 4.573 0 0 1-4.018 6.752h-32.168a4.57 4.57 0 0 1-3.991-6.8l4.845-8.683z",
  className: "cls-1",
  "data-name": "Caminho 7973",
  transform: "translate(-232.6 -647.955)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3701",
  "data-name": "Grupo 3701",
  transform: "translate(6.472 33.069)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7974",
  d: "M245.043 671.56a21.545 21.545 0 0 1-8.383-1.631 2.017 2.017 0 1 1 1.692-3.661 18.192 18.192 0 0 0 14.3-.482c8.869-4.307 15.894-2.85 16.188-2.781a2.015 2.015 0 0 1-.849 3.939c-.078-.013-6.046-1.19-13.577 2.469a21.3 21.3 0 0 1-9.371 2.147z",
  className: "cls-1",
  "data-name": "Caminho 7974",
  transform: "translate(-235.488 -662.713)"
}));

var SvgExams = function SvgExams(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3702",
    width: 49.383,
    height: 60.314,
    "data-name": "Grupo 3702",
    viewBox: "0 0 49.383 60.314",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExams, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exams.2d191a08.svg";
export { ForwardRef as ReactComponent };